export const faqUrl = "https://www.dtb.de/turnportal/faq-turnportal";
export const faqClubUrl = "https://www.dtb.de/turnportal/faq-turnportal-verein-wettkampf/";
export const faqCompetitionUrl =
  "https://www.dtb.de/turnportal/faq-turnportal-verein/#c8228";
